import React from "react";
import { useTranslation } from "react-i18next";

import "./OOSIndicator.scss";

interface IOOSIndicatorProps {
	"data-testid"?: string;
}

const OOSIndicator: React.FC<IOOSIndicatorProps> = ({ "data-testid": dataTestId }) => {
	const { t } = useTranslation();

	return (
		<div className="OOSIndicator" data-testid={dataTestId}>
			<div className="OOSOverlay">
				<span className="OOSText">{t("product.outOfStock")}</span>
			</div>
		</div>
	);
};

export default OOSIndicator;
